<template>
  <div class="league" id="league" v-on:click="download">
    <template v-if="league">

      <header>
        <div class="title">{{league[lang].title}}</div><br>
        <div class="subtitle">{{league[lang].subtitle}}</div>
      </header>

      <table>
        <thead>
          <tr>
            <th></th>
            <th>{{league[lang].countryLabel}}</th>
            <th v-if="namedMinisters > 0">{{league[lang].ministerLabel}}</th>
            <th class="quota">{{league[lang].quotaLabel}}</th>
          </tr>
        </thead>

        <tbody>
          <tr class="bg-waves">
            <td colspan="4"></td>
          </tr>
          <tr v-for="(index, dataPoint) in dataPoints">
            <td>
              <h2 class="rank font-steagal-bold">{{index+1}}<sup class="f05">{{index+1 | ordinal lang}}</sup></h2>
            </td>
            <td>
              <h2 class="rank">
                <country :key="dataPoint.countryKey" :lang="lang"></country>
              </h2>
            </td>
            <td v-if="namedMinisters > 0">
              <h2 class="person italic">
                <person :key="dataPoint.peopleKeys"></person>
              </h2>
            </td>
            <td class="quota">
              <h2 class="quota">{{dataPoint | percentOver}}</h2>
              <h3 class="quota-label">{{dataPoint | quotaOver}} {{league[lang].quotaUnitLabel}}</h3>
            </td>
          </tr>
        </tbody>
      </table>
      <footer>
        <div class="columns">
          <div class="column is-10 is-offset-1">
            <h2>{{league[lang].fishLabel}}</h2>
            <div class="fishes level">
              <div v-for="(key, fish) in league.fishes" class="fish">
                <fish :key="key" :lang="lang"></fish>
              </div>
            </div>
            <img src="/static/img/nef_logo.png" class="nef-logo" /><br>
            <a class="nef-link black" href="http://neweconomics.org">neweconomics.org</a>
          </div>
        </div>
      </footer>
    </template>
  </div>

</template>

<script>
  import Fish from '../components/Fish.vue'
  import Country from '../components/Country.vue'
  import Person from '../components/Person.vue'
  import fb from 'firebase'
  import {saveAs} from 'file-saver'
  import domtoimage from 'dom-to-image'
  import _ from 'underscore'
  import numeral from 'numeral'

  export default {

    components: {
      Fish,
      Country,
      Person
    },

    data: function () {
      return {
        lang: null,
        league: null,
        dataPoints: [],
        namedMinisters: 0
      }
    },

    ready: function() {
      var self = this

      if (this.$route.params.lang) {
        this.lang = this.$route.params.lang
      } else {
        this.lang = 'en'
      }

      fb.database().ref('leagues').child(this.$route.params.key)
        .on('value', function(snapshot) {
          self.league = snapshot.val()
          self.getData()
        })
    },

    methods: {

      getData: function() {
        let self = this
        console.log('Getting data: ', this.league.year, this.league.region)
        let dataPointsRef = fb.database().ref('countryDataPoints')
          .orderByChild('region')
          .equalTo(this.league.region)
          .on('value', function(snapshot) {
            let dataPoints = snapshot.val()

            _.each(dataPoints, function(dataPoint, i) {
              if (dataPoint.year == self.league.year) {
                dataPoint.percentOver = (100/dataPoint.quotaAdvice*dataPoint.quotaSet)-100
                self.dataPoints.push(dataPoint)
              }
            })

            let count = self.$route.query.count
            if (count) {
              self.dataPoints = _.sortBy(self.dataPoints, "percentOver").reverse().slice(0,count)
            } else {
              self.dataPoints = _.sortBy(self.dataPoints, "percentOver").reverse()
            }

            self.fetchPeople()

          })
      },

      fetchPeople: function() {
        let self = this

        _.each(self.dataPoints, function(dataPoint) {
          fb.database().ref('people').child(dataPoint.peopleKeys).on('value', function(snapshot) {
            console.log(snapshot.val())
            let minister = snapshot.val()
            if (minister.name && minister.name.trim().length > 0) self.namedMinisters++
          })
        })
      },

      download: function() {
        console.log("Downloading...")
        let el = document.getElementById('league'),
        scale = 3

        domtoimage.toBlob(el, {
          quality: 1,
          width: el.clientWidth*scale,
          height: el.clientHeight*scale,
          bgcolor: '#ffffff',
          style: {
            'transform': 'scale(' + scale + ')',
            'transform-origin': 'top left'
          }
        })
        .then(function (blob) {
          saveAs(blob, 'league.png');
        });
      }
    }
  }
</script>

<style lang="less" scoped>
  @nefBlue: #82b5e1;

  /* Functional classes */
  .black { color: black; }

  .italic { font-style: italic; }

  .font-steagal-bold {
    text-transform: uppercase;
    font-family: 'steagalbold';
  }

  .bg-waves {
    background: url('/static/img/wave.png') !important;
    background-repeat: repeat-x;
    background-size: contain !important;

    td {
      padding: 0.9rem;
    }
  }

  .f05 { font-size: 1rem; padding-left:0.25rem; }
  /* End functional classes */

  .league {
    background: url('/static/img/img_clouds.png');
    background-repeat: no-repeat;
    background-size: 200px;
    background-position: 100px 40px;
    padding: 30px 0 30px 0;
  }

  header, footer {
    text-align: center;
    .fishes {
      text-align: center;
    }
  }

  header {
    margin: 4rem 0;
    text-transform: uppercase;
    font-family: 'steagalbold';

    .title {
      background: url('/static/img/stripe1.png');
      background-repeat: no-repeat;
      height: 130px;
      display: inline-block;
      background-size: cover;
      padding: 2rem 1rem;
      font-size: 5rem;
      background-position: -0.45rem -1rem;
      overflow: visible;
      background-clip: border-box;
    }

    .subtitle {
      background: url('/static/img/stripe2.png');
      background-size: cover;
      background-repeat: no-repeat;
      height: 130px;
      display: inline-block;
      background-size: contain;
      padding: 1rem;
      font-size: 6rem;
      color: black;
      font-family: 'steagallight';
      text-align: right;
      position: relative;
      left: 10rem;
      top:-1rem;
    }
  }

  footer {
    text-transform: uppercase;
    font-family: 'steagalbold';
    margin-top: 2rem;
    margin-bottom: 3rem;
    color: @nefBlue;

    h2 {
      font-size: 3rem;
    }
  }

  table {

    thead {
      text-transform: uppercase;
      font-family: 'steagalbold';
      /*
      background: url('/static/img/img_wave.png');*/
      background-repeat: repeat-x;
      background-position: bottom;

      th {
        font-size: 1.5rem;
        color: @nefBlue;
        vertical-align: middle;

        &.quota {
          width: 25%;
          text-align: right;
          padding: 1.5rem;
        }
      }
    }

    tbody {
      tr {
        td {
          color: hsla(208, 61%, 100%-3.5*1, 1);
          text-shadow: 0 1px 0 rgba(255,255,255,0.2), 0 2px 0 rgba(255,255,255,0.2) !important;
          vertical-align: middle;
          padding: 1.5rem;

          &.quota {
            width: 25%;
            text-align: right;
          }
        }
      }

      tr:nth-child(1) {
        td { color: darken(@nefBlue, 85%); }
        background: hsla(208, 61%, 70%, 1);
      }
      tr:nth-child(2) {
        td { color: darken(@nefBlue, 85%); }
        background: hsla(208, 61%, 70%-3.5*1, 1);
      }
      tr:nth-child(3) {
        td { color: darken(@nefBlue, 85%); }
        background: hsla(208, 61%, 70%-3.5*2, 1);
      }
      tr:nth-child(4) {
        td { color: darken(@nefBlue, 85%); }
        background: hsla(208, 61%, 70%-3.5*3, 1);
      }
      tr:nth-child(5) {
        td { color: darken(@nefBlue, 85%); }
        background: hsla(208, 61%, 70%-3.5*4, 1);
      }
      tr:nth-child(6) {
        td { color: darken(@nefBlue, 85%); }
        background: hsla(208, 61%, 70%-3.5*5, 1);
      }
      tr:nth-child(7) {
        td { color: darken(@nefBlue, 85%); }
        background: hsla(208, 61%, 70%-3.5*6, 1);
      }
      tr:nth-child(8) { background: hsla(208, 61%, 70%-3.5*7, 1); }
      tr:nth-child(9) { background: hsla(208, 61%, 70%-3.5*8, 1); }
      tr:nth-child(10) { background: hsla(208, 61%, 70%-3.5*9, 1); }
      tr:nth-child(11) { background: hsla(208, 61%, 70%-3.5*10, 1); }
      tr:nth-child(12) { background: hsla(208, 61%, 70%-3.5*11, 1); }
      tr:nth-child(13) { background: hsla(208, 61%, 70%-3.5*12, 1); }
      tr:nth-child(14) { background: hsla(208, 61%, 70%-3.5*13, 1); }
      tr:nth-child(15) { background: hsla(208, 61%, 70%-3.5*14, 1); }
      tr:nth-child(16) { background: hsla(208, 61%, 70%-3.5*15, 1); }
      tr:nth-child(17) { background: hsla(208, 61%, 70%-3.5*16, 1); }
      tr:nth-child(18) { background: hsla(208, 61%, 70%-3.5*17, 1); }
      tr:nth-child(19) { background: hsla(208, 61%, 70%-3.5*18, 1); }
      tr:nth-child(20) { background: hsla(208, 61%, 70%-3.5*19, 1); }
      tr:nth-child(21) { background: hsla(208, 61%, 70%-3.5*20, 1); }
    }
  }

  header {
    h1 {
      font-size: 6rem;
      color: @nefBlue;
      margin-bottom: 0px;
      line-height: 6rem;
    }

    h2 {
      font-size: 6rem;
      color: @nefBlue;
      opacity: 0.5;
      line-height: 6rem;
    }
  }

  h2.rank,
  h2.country-name,
  h2.person,
  h2.quota {
    font-weight: 700;
    font-size: 2rem;
  }

  h3.quota-label {
    font-family: 'steagalbold';
    text-transform: uppercase;
    opacity: 0.5;
    letter-spacing: 2px;
    font-size: 18px;
  }

  .nef-logo {
    width: 200px;
  }

  .nef-link {
    font-size: 2rem;
    font-weight: bold;
  }

  .fish {
    font-family: 'steagalbold';
    text-transform: uppercase;
    font-size: 1.5rem;
    letter-spacing: 1px;
    color: @nefBlue;
    img {
      margin-bottom: 10px;
    }
    span {
      margin-top: 10px;
      opacity: 0.5;
    }
    text-align: center;
  }

</style>



/** WEBPACK FOOTER **
 ** League.vue?5de72f6b
 **/